import React, { FunctionComponent } from 'react';
import { Box, Grid, useTheme } from '@material-ui/core';
import { useReactiveVar } from '@apollo/client';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import useToggleFinCalcSpc from '../../../../../../common/react/useToggleFinCalcSpc';
import stringUtilities from '../../../../../../../../common/utilities/stringUtilities';
import SummaryTestDriveLink from './summaryTestDriveLink/SummaryTestDriveLink';
import SummaryBrochureLink from './summaryBrochureLink/SummaryBrochureLink';
import SummaryFinanceEditLink from './summaryFinanceEditLink/SummaryFinanceEditLink';
import clsx from 'clsx';
import summaryLinksStyles from './summaryLinksStyles';
import { FinanceResultType } from '../../../../../../__generated__/globalTypes';
import SummaryValueMyCarLink from './summaryValueMyCarLink/SummaryValueMyCarLink';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { brochureUrlVar } from '../../../../../../gqlCommon/graphql/cache';
import SummaryTradeInLink from './summaryTradeInLink/SummaryTradeInLink';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

const SummaryLinksContainer: FunctionComponent = () => {
  const {
    configuration: { testDriveUrl, valueMyCarUrl, tradeInUrl },
  } = useWidgetContext();
  const {
    platformConfig: { isFinanceEnabled },
  } = usePlatformConfig();
  const { selectedCar } = useCustomizeCarContext();
  const hasModelParam = testDriveUrl?.includes('?model_name=') || testDriveUrl?.includes('?model=');
  const hasIdParam = testDriveUrl?.includes('?id=');
  const modelName = hasModelParam ? stringUtilities.slugify(selectedCar?.car?.trim?.attributes?.label) : '';
  const id = hasIdParam ? selectedCar?.car?.attributes?.externalSku : '';
  const testDriveUrlCompleted = testDriveUrl + modelName + id;
  const isFullLinksDisplay = !!testDriveUrl && isFinanceEnabled;
  const isCash = selectedCar?.finance?.type === FinanceResultType.cash;
  const { toggleFinanceCalculatorSpc } = useToggleFinCalcSpc();
  const styles = summaryLinksStyles();
  const className = styles.summaryIconGrid;
  const isLeftAligned = !!valueMyCarUrl && isFullLinksDisplay && !isCash;
  const {
    spc: {
      customise: { showBrochureLinkInSummary },
    },
  } = useTheme<ISpcTheme>();
  const brochureUrl = useReactiveVar(brochureUrlVar);

  return (
    <>
      <Box mt={2} className={styles.summaryLinkWrapper}>
        <Grid
          container={true}
          wrap={'wrap'}
          justifyContent={'center'}
          className={clsx(styles.container, { [styles.fullLinksDisplay]: isFullLinksDisplay && !isCash })}
        >
          {!!valueMyCarUrl && (
            <Grid item className={className} xs={6}>
              <SummaryValueMyCarLink valueMyCarUrl={valueMyCarUrl} centered={!isLeftAligned} />
            </Grid>
          )}

          {tradeInUrl && (
            <Grid item className={className} xs={6}>
              <SummaryTradeInLink tradeInUrl={tradeInUrl} centered={!isLeftAligned} />
            </Grid>
          )}

          {!!testDriveUrl && (
            <Grid item className={className} xs={6}>
              <SummaryTestDriveLink testDriveUrl={testDriveUrlCompleted} centered={!isLeftAligned} />
            </Grid>
          )}

          {isFinanceEnabled && !isCash && (
            <Grid item className={className} xs={6}>
              <SummaryFinanceEditLink toggleFC={toggleFinanceCalculatorSpc} centered={!isLeftAligned} />
            </Grid>
          )}
          {brochureUrl && showBrochureLinkInSummary && (
            <Grid item className={className} xs={6}>
              <SummaryBrochureLink brochureUrl={brochureUrl} centered={!isLeftAligned} />
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default SummaryLinksContainer;
